import api from '../../api';
import { push } from 'connected-react-router';
import { store as storeNotification } from 'react-notifications-component';
import { socket } from './../store/socket';

const notificationConfig = {
  container: 'top-center',
  animationIn: ['animated', 'fadeIn'],
  animationOut: ['animated', 'fadeOut'],
  dismiss: {
    duration: 1500,
    showIcon: true
  }
};

export const petsStartRequest = () => {
  return {
    type: 'PETS_START_REQUEST'
  };
};

export const petsEndRequest = () => {
  return {
    type: 'PETS_END_REQUEST'
  };
};

export const getAllPetsSuccess = ({ data }) => {
  return {
    type: 'PETS_GET_ALL_SUCCESS',
    payload: data
  };
};

export const getAllPetsError = error => {
  return {
    type: 'PETS_GET_ALL_ERROR',
    payload: error
  };
};

export const addPetsSuccess = ({ data }) => {
  return {
    type: 'PETS_ADD_SUCCESS',
    payload: data
  };
};

export const addPetsError = error => {
  return {
    type: 'PETS_ADD_ERROR',
    payload: error
  };
};

export const editPetsSuccess = ({ data }) => {
  return {
    type: 'PETS_EDIT_SUCCESS',
    payload: data
  };
};

export const editPetsError = error => {
  return {
    type: 'PETS_EDIT_ERROR',
    payload: error
  };
};

export const removePetsSuccess = id => {
  return {
    type: 'PETS_REMOVE_SUCCESS',
    payload: id
  };
};

export const removePetsError = error => {
  return {
    type: 'PETS_REMOVE_ERROR',
    payload: error
  };
};

export const petsModifyStore = ({ data }) => {
  return {
    type: 'PETS_MODIFY_STORE',
    payload: data
  };
};

export const addPets = (data, formReset, submitBtn) => {
  return async dispatch => {
    try {
      submitBtn.disabled = true;
      dispatch(petsStartRequest());
      const response = await api().post('/api/pets', {
        ...data,
        image: undefined
      });
      if (data.image) {
        const formData = new FormData();
        formData.append('image', data.image);
        formData.append('pet', response.data._id);
        await api().post('/api/pets/image', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
      }
      dispatch(addPetsSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'ADD',
        module: 'pets',
        data: [response.data],
        company: response.data.company
      });
      formReset();
    } catch (err) {
      dispatch(addPetsError(err));
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      setTimeout(() => {
        dispatch(petsEndRequest());
        submitBtn.disabled = false;
      }, 1800);
    }
  };
};

export const getAllPets = (params = {}) => {
  return async dispatch => {
    try {
      dispatch(petsStartRequest());
      const response = await api().get('/api/pets', { params });
      dispatch(getAllPetsSuccess(response));
    } catch (err) {
      dispatch(getAllPetsError(err));
    } finally {
      dispatch(petsEndRequest());
    }
  };
};

export const editPets = (data, submitBtn = {}, handleModalClose) => {
  return async dispatch => {
    const defaultMsg = button => {
      return new Promise(resolve => {
        document
          .getElementsByClassName('page-content')[0]
          .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        setTimeout(() => {
          dispatch(petsEndRequest());
          button.disabled = false;
          resolve(true);
        }, 1800);
      });
    };

    try {
      submitBtn.disabled = true;
      dispatch(petsStartRequest());
      const id = data._id;
      const response = await api().put('/api/pets/' + id, {
        ...data,
        image: undefined
      });
      if (data.image) {
        const formData = new FormData();
        formData.append('image', data.image);
        formData.append('pet', response.data._id);
        await api().post('/api/pets/image', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
      }
      dispatch(editPetsSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'EDIT',
        module: 'pets',
        data: [response.data],
        company: response.data.company
      });
      await defaultMsg(submitBtn);
      if (handleModalClose) {
        handleModalClose();
      } else {
        dispatch(push('/pets'));
      }
    } catch (err) {
      dispatch(editPetsError(err));
      await defaultMsg(submitBtn);
    }
  };
};

export const removePets = id => {
  return async dispatch => {
    try {
      dispatch(petsStartRequest());
      await api().delete('/api/pets/' + id);
      dispatch(removePetsSuccess(id));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'REMOVE',
        module: 'pets',
        data: id
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Pet removido com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(removePetsError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao remover pet.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(petsEndRequest());
    }
  };
};

export const restorePets = data => {
  return async dispatch => {
    try {
      dispatch(petsStartRequest());
      const id = data._id;
      const response = await api().put('/api/pets/' + id, data);
      dispatch(editPetsSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'RESTORE',
        module: 'pets',
        data: [response.data],
        company: response.data.company
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Pet restaurado com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(editPetsError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao restaurar pet.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(petsEndRequest());
    }
  };
};
